

export enum QueryStatusEnum  {
    LOADING="loading",
    ERROR ="error",
    SUCCESS="success",
    IDLE ="idle" 
}
